import getLocal from 'eco-design-reliance/getLocal';
import { i18n } from '../../i18n';
import EcoCartClose from '../../icons/EcoCartClose';
import './index.scss';
import { ItfEcoCartHeader } from './type.d';

const EcoCartHeader: React.FC<ItfEcoCartHeader> = ({ callback }) => {
    const { locale = '' } = getLocal();
    const t = i18n?.[locale] || i18n.en;

    return (
        <div className="eco-cart-header">
            <p className="eco-cart-title">{t.cart_title}</p>
            <div className="eco-cart-close" onClick={callback}>
                <EcoCartClose />
            </div>
        </div>
    );
};

export default EcoCartHeader;
